import { DEFAULT_STORE } from "./default_store";
/* a similar pattern to other automerge init functions */
export function init(doc) {
    Object.assign(doc, DEFAULT_STORE);
}
export { useAutomergeStore } from "./useAutomergeStore";
